{
  "authErrors": [
    "AUTH_MISSING_TOKEN",
    "AUTH_INVALID_TOKEN",
    "AUTH_FAILED"
  ],
  "transientErrors": [
    "AUTH_SERVER_UNAVAILABLE"
  ]
}
